import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { APIClient } from "src/app/core/api-client/contracts/api-client.service";
import { ICreateDevice } from "src/app/shared/models/IDevice";
import { DisassociateRequest, IPatientDeviceAssociation, SearchRequest } from "src/app/shared/models/search-request";

@Injectable({
  providedIn: 'root'
})
export class ClinicalService {

  private subject = new BehaviorSubject<any>({});
  resource = 'clinician';
  constructor(private client: APIClient) { }

  searchPatientOrDeviceId(request: SearchRequest): Observable<SearchRequest> {
    return this.client.post<SearchRequest>(`${this.resource}/search`, request);
  }
  
  addPatientDeviceAssociation(request: IPatientDeviceAssociation[]): Observable<IPatientDeviceAssociation[]> {
    return this.client.post<IPatientDeviceAssociation[]>(`${this.resource}/association`, request);
  }

  disassociatePatientDeviceAssociation(request: DisassociateRequest ): Observable<any> {
    return this.client.post<DisassociateRequest>(`${this.resource}/disassociate`, request);
  }

  disassociateAllPatientDeviceAssociation(request: DisassociateRequest[]): Observable<any> {
    return this.client.post<DisassociateRequest[]>(`${this.resource}/disassociateall`, request);
  }

  sendPatientDeviceDetailData(response: SearchRequest) {
    this.subject.next({ response: response });
  }

  getPatientDeviceDetailData(): Observable<any> {
    return this.subject.asObservable();
  }

  createClinicianDevice(device: ICreateDevice): Observable<any> {
    return this.client.post<ICreateDevice>(`${this.resource}/createdevice`, device);
  }
}
